<div class="multiple-select-dropdown" [ngClass]="uniqueClassName">
  <span class="name" >{{ name }}</span>
  <div [class.multiple-select-dropdown-focused]="focused">
    <ng-multiselect-dropdown [placeholder]="placeholder" [settings]="dropdownSettings"
                             [data]="dropdownList" [(ngModel)]="selectedItems" [disabled]="disabled"
                             (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)">
    </ng-multiselect-dropdown>
  </div>
</div>
